const validators = {};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/validators/action-validators.js